const BASE = process.env.ENV === 'preview' ? 'api/gp-chat-staging' : 'api/gp-chat'
const urls = {
  /*
  * 获取播主最近50条消息
  * */
  getTeacherMsg: 'get /api/app/chat/getTeacherMsg',
  // 获取群聊最近50条消息
  getRoomMsg: 'get /api/app/chat/getRoomMsg',
  // 通过roomId 获取sourceId
  getSourceId: 'get /api/app/chat/getGroup',
  // 判断是否在群聊中
  isMember: 'get /chat/isMember'
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}

export default URLS



// WEBPACK FOOTER //
// ./src/apis/api-urls/gp-chat.js